export const uf = [
  {id: '0', value: 'AC'},
  {id: '1', value: 'AL'},
  {id: '2', value: 'AP'},
  {id: '3', value: 'AM'},
  {id: '4', value: 'BA'},
  {id: '5', value: 'CE'},
  {id: '6', value: 'DF'},
  {id: '7', value: 'ES'},
  {id: '8', value: 'GO'},
  {id: '9', value: 'MA'},
  {id: '10', value: 'MT'},
  {id: '11', value: 'MS'},
  {id: '12', value: 'MG'},
  {id: '13', value: 'PA'},
  {id: '14', value: 'PB'},
  {id: '15', value: 'PR'},
  {id: '16', value: 'PE'},
  {id: '17', value: 'PI'},
  {id: '18', value: 'RJ'},
  {id: '19', value: 'RN'},
  {id: '20', value: 'RS'},
  {id: '21', value: 'RO'},
  {id: '22', value: 'RR'},
  {id: '23', value: 'SC'},
  {id: '24', value: 'SP'},
  {id: '25', value: 'SE'},
  {id: '26', value: 'TO'}
]
